package com.eladfinish.bible.contest.common.usecases

import com.eladfinish.bible.contest.extensions.runIf
import com.eladfinish.bible.contest.features.copyOptions.CopyOptions

class RemoveNikudAndTeamimIfNeedUseCase(
    private val removeGodNamesUseCase: RemoveGodNamesUseCase,
    private val removeTeamimUseCase: RemoveTeamimUseCase,
    private val removeNikudUseCase: RemoveNikudUseCase,
) {

    operator fun invoke(
        text: String,
        copyOptions: CopyOptions,
    ): String =
        text
            .runIf(!copyOptions.withNikud) {
                removeNikudUseCase(pasuk = this)
            }
            .runIf(!copyOptions.withTeamim) {
                removeTeamimUseCase(pasuk = this)
            }
            .runIf(copyOptions.hideGodNames) {
                removeGodNamesUseCase(pasuk = this)
            }

}
